import { Container, Row, Col, Badge } from 'react-bootstrap';
import { useLocation, Navigate } from 'react-router-dom';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RiFileCopyFill } from '@remixicon/react';
import Copied from '../../../../components/Copied/Copied';
import { handleCopyToClipboard } from '../../../../utils/helpers.js';
import InfoBanner from '../../../../components/InfoBanner/InfoBanner.jsx';
import useSubscriptionStore from '../../../../stores/subscriptionStore.js';

function CGVGeneratedScreen() {
    const { t } = useTranslation();
    const location = useLocation();
    const cgv = location.state?.cgv;
    const timerRef = useRef(null);
    const [showCopiedModal, setShowCopiedModal] = useState(false);
    const { isDemo } = useSubscriptionStore();

    if (!cgv) {
        return <Navigate to="/" />;
    }

    return (
        <>
            <Container className="py-5">
                {isDemo && (
                    <InfoBanner />
                )}
                <Row className="mb-4">
                    <Col xs={12} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('cgv.title')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(cgv.title, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title="Copier"
                                />
                            </div>
                            <p className="card-text">{cgv.title}</p>
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4 g-4">
                    <Col xs={12} md={12} lg={6} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('cgv.slug')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(cgv.slug, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('buttons.copy')}
                                />
                            </div>
                            <p className="card-text">{cgv.slug}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="card-title text-uppercase">{t('cgv.metaDescription')}</h3>
                                <RiFileCopyFill
                                    size={18}
                                    onClick={() => handleCopyToClipboard(cgv.metaDescription, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('buttons.copy')}
                                />
                            </div>
                            <p className="card-text">{cgv.metaDescription}</p>
                        </div>
                    </Col>
                </Row>

                <Row className="mb-4">
                    <Col xs={12} className="d-flex">
                        <div className="card-custom-content">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <h3 className="card-title text-uppercase">{t('app.content')}</h3>
                                    <Badge bg="light" text="dark">{t('app.html')}</Badge>
                                </div>
                                <RiFileCopyFill
                                    size={20}
                                    onClick={() => handleCopyToClipboard(cgv.cgvHtml, timerRef, setShowCopiedModal)}
                                    role="button"
                                    className="copy-icon"
                                    title={t('cgv.copyHtml', 'Copier le HTML')}
                                />
                            </div>
                            <div className="max-h-600 overflow-y-auto hide-scrollbar" dangerouslySetInnerHTML={{ __html: cgv.cgvHtml }} />
                        </div>
                    </Col>
                </Row>
            </Container>

            <Copied
                show={showCopiedModal}
                onHide={() => setShowCopiedModal(false)}
            />
        </>
    );
}

export default CGVGeneratedScreen;
